import { NgModule, inject, provideAppInitializer } from '@angular/core';
import {
	Translation,
	TRANSLOCO_CONFIG,
	TRANSLOCO_LOADER,
	translocoConfig,
	TranslocoModule,
	TranslocoService,
} from '@ngneat/transloco';

import TranslocoHttpLoader from 'app/core/transloco/transloco.http-loader';

@NgModule({
	exports: [TranslocoModule],
	providers: [
		{
			// Provide the default Transloco configuration
			provide: TRANSLOCO_CONFIG,
			useValue: translocoConfig({
				availableLangs: [
					{
						id: 'en',
						label: 'English',
					},
					{
						id: 'el',
						label: 'Greek',
					},
				],
				defaultLang: 'en',
				fallbackLang: 'en',
				reRenderOnLangChange: true,
				prodMode: true,
			}),
		},
		{
			// Provide the default Transloco loader
			provide: TRANSLOCO_LOADER,
			useClass: TranslocoHttpLoader,
		},
		provideAppInitializer(() => {
			const initializerFn = (
				(translocoService: TranslocoService): any =>
				(): Promise<Translation> => {
					const defaultLang = translocoService.getDefaultLang();
					translocoService.setActiveLang(defaultLang);
					return translocoService.load(defaultLang).toPromise();
				}
			)(inject(TranslocoService));
			return initializerFn();
		}),
	],
})
export class TranslocoCoreModule {}
